import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

const FormDialog = ({
  open,
  handleClose,
  title,
  handleSubmit,
  children,
  submitLoading,
  disabled,
  submitLabel = 'Submit',
  cancelVariant = 'contained',
  cancelColor = 'secondary',
}) => {
  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions sx={{ margin: '20px 20px' }}>
          <Button
            variant={cancelVariant}
            color={cancelColor}
            onClick={handleClose}
            sx={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disabled={disabled || submitLoading}
          >
            {submitLoading ? 'Loading..' : submitLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FormDialog;
